import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import EpisodeCard from "@/components/EpisodeCard";

export default function PodcastRow({ title, subtitle, episodes, onPlay, dark = false }) {
  const ref = useRef(null);

  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  if (!episodes?.length) return null;

  return (
    <section className="mb-6" data-testid={`row-${title.replace(/\s+/g, "-").toLowerCase()}`}>
      <div className="flex items-end justify-between px-6 mb-1">
        <div>
          <h3 className={`font-display text-3xl md:text-4xl tracking-wider ${dark ? "text-white" : "text-[#14100B]"}`}>
            {title.toUpperCase()}
          </h3>
          {subtitle && <p className={`text-sm mt-1 ${dark ? "text-white/50" : "text-[#6B5A48]"}`}>{subtitle}</p>}
        </div>
        <div className="hidden md:flex items-center gap-2">
          <button
            onClick={() => scroll(-1)}
            aria-label="Précédent"
            className={`h-9 w-9 rounded-full flex items-center justify-center transition ${
              dark
                ? "border border-white/20 text-white hover:bg-white/10"
                : "border border-[#E5D9C5] text-[#14100B] hover:bg-[#F5EDDE]"
            }`}
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={() => scroll(1)}
            aria-label="Suivant"
            className={`h-9 w-9 rounded-full flex items-center justify-center transition ${
              dark
                ? "border border-white/20 text-white hover:bg-white/10"
                : "border border-[#E5D9C5] text-[#14100B] hover:bg-[#F5EDDE]"
            }`}
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
      <div className="jt-row" ref={ref}>
        {episodes.map((ep) => (
          <EpisodeCard key={ep.id} episode={ep} onPlay={onPlay} dark={dark} />
        ))}
      </div>
    </section>
  );
}
